import deleteItemRequest from 'owa-service/lib/factory/deleteItemRequest';
import itemId from 'owa-service/lib/factory/itemId';
import deleteItemOperation from 'owa-service/lib/operation/deleteItemOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
function createItemIdForRequest(itemIdType) {
    return itemId({
        Id: itemIdType.Id,
        ChangeKey: itemIdType.ChangeKey,
    });
}
function configureRequestBody(itemIds, disposalType) {
    return deleteItemRequest({
        ItemIds: itemIds.map(function (itemId) { return createItemIdForRequest(itemId); }),
        DeleteType: disposalType,
        SuppressReadReceipts: true,
        ReturnMovedItemIds: true,
        SendMeetingCancellations: 'SendToNone',
        AffectedTaskOccurrences: 'AllOccurrences',
    });
}
export default function deleteItemService(itemIds, disposalType, requestInitOptions) {
    var requestBody = configureRequestBody(itemIds, disposalType);
    return deleteItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }, requestInitOptions).then(function (response) {
        return response.Body.ResponseMessages.Items;
    });
}
//# sourceMappingURL=deleteItemService.js.map